// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"_1e1zGCaz","label":"_2VTRVv2T","dollarSign":"_3Yo45IPG","input":"_1QvOz6Zd"};